export default __webpack_public_path__ + "static/media/receipt_long.66efca40.svg";